import { Col, Row } from "reactstrap";
import { useSelector } from "react-redux";
import DynamicTable from "./DynamicTable";
import "./DynamicTableWrapper.scss";

const DynamicTableWrapper = ({
  data,
  config,
  pageInfo,
  pageRequest,
  pageRequestSet,
  setTableConfig,
  jobId,
  expandedRow,
  closeTag
}) => {
  const isRecommendLoading = useSelector(
    (state) => state.CandidateReducer.candidateRecommendationLoading
  );
  return (
    <Row>
      <Col lg={12}>
        <div className="listjs-table" style={{ height: "calc(100vh - 225px)" }}>
          <DynamicTable
            config={config}
            data={data}
            setTableConfig={setTableConfig}
            pageRequestSet={pageRequestSet}
            pageInfo={pageInfo}
            freezeHeader={true}
            isLoading={isRecommendLoading}
            tableHeight="100%"
            pageRequest={pageRequest}
            jobId={jobId}
            expandedRow={expandedRow}
            closeTag={closeTag}
          />
        </div>
      </Col>
    </Row>
  );
};

export default DynamicTableWrapper;
